import { useContext } from 'react';

import { WidgetPageContext } from '@app/context';

import { PageLoading } from '../PageLoading';

import { PageFallbackSideMenu } from './PageFallbackSideMenu';
import { PageFallbackHeader } from './PageFallbackHeader';

export const PageFallback = () => {
  const page = useContext(WidgetPageContext);

  switch (page.id) {
    case 'sideMenu':
      return <PageFallbackSideMenu />;
    case 'header':
      return <PageFallbackHeader />;
    default:
      return <PageLoading />;
  }
};
